/**
 * Category id for "Доп. номенклатура" (Additional Nomenclature).
 * This id (4) is stable and used across the app to identify this product category
 * (see also revenue-by-product.component.ts which uses the same id to filter
 * additional nomenclature products from report data).
 */
export const ADDITIONAL_NOMENCLATURE_CATEGORY_ID = 4;
